import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { Assessment, AssessmentSearch } from 'src/app/models/assessment';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Ward } from '../ward-manage/ward';
import { WardService } from 'src/app/services/ward.service';
import { UnionDomain } from 'src/app/services/union.domain';
import { FormControl, FormGroup } from '@angular/forms';
import * as XLSX from 'xlsx';
import { SubdomainService } from 'src/app/services/subdomain.service';
@Component({
  selector: 'app-assessment-print',
  templateUrl: './assessment-print.component.html',
  styleUrls: ['./assessment-print.component.scss'],
})
export class AssessmentPrintComponent {
  $subscriptions: Subscription[] = [];
  assessmentList: Assessment[] = [];
  wardList: Ward[] = [];
  assessmentSearchForm!: FormGroup;
  toastr: any;
  fileName!: string;

  constructor(
    private assessmentService: AssessmentService,
    private wardService: WardService,
    public unionDomain: UnionDomain,
    private subdomainService: SubdomainService
  ) {}

  async ngOnInit(): Promise<void> {
    this.getAssessmentList();
    await this.getWards();
    this.initializeForm();
    this.fileName = this.subdomainService.getSubdomain() + '_Excel_Sheet.xlsx';
  }

  private initializeForm = (formData?: AssessmentSearch) => {
    this.assessmentSearchForm = new FormGroup({
      ward_number: new FormControl(
        formData?.ward_number ? formData.ward_number : '0'
      ),
      holding_number: new FormControl(
        formData?.holding_number ? formData.holding_number : ''
      ),
      gram_or_rasta: new FormControl(
        formData?.gram_or_rasta ? formData.gram_or_rasta : ''
      ),
      serial_no_start: new FormControl(
        formData?.serial_no_start ? formData.serial_no_start : '1'
      ),
      serial_no_end: new FormControl(
        formData?.serial_no_end ? formData.serial_no_end : '10000000'
      ),
    });
  };

  ngOnDestroy(): void {
    this.$subscriptions.forEach((s) => s.unsubscribe());
  }

  private getAssessmentList = (): void => {
    this.$subscriptions.push(
      this.assessmentService.getAssessmentList(true).subscribe({
        next: (res) => {
          this.assessmentList = res.data;
          // this.assessmentList.sort((a, b) =>
          //   this.unionDomain.getEquivalentSortingNumber(a.holding_number) <
          //   this.unionDomain.getEquivalentSortingNumber(b.holding_number)
          //     ? -1
          //     : 1
          // );
        },
      })
    );
  };

  private getWards = async (): Promise<void> => {
    this.$subscriptions.push(
      this.wardService.getWardList().subscribe({
        next: (res: any) => {
          this.wardList = res;
        },
      })
    );
  };

  public async onSubmit() {
    (
      await this.assessmentService.getFilteredAssessmentList(
        this.assessmentSearchForm.value,
        true
      )
    ).subscribe({
      next: (res) => {
        this.assessmentList = res.data;
        this.toastr.success(res.message);
      },
      error: (err) => {
        this.toastr.error(err.error.message);
      },
    });
  }
  exportTableToExcel() {
    let element = document.getElementById('demo');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }
}
